import { render, staticRenderFns } from "./CoHeader.vue?vue&type=template&id=9272864c&scoped=true&"
import script from "./CoHeader.vue?vue&type=script&lang=ts&"
export * from "./CoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CoHeader.vue?vue&type=style&index=0&id=9272864c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9272864c",
  null
  
)

export default component.exports